/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkEditRequestBulkEditReleaseLink
 */
export interface BulkEditRequestBulkEditReleaseLink {
    /**
     * Existing release id (from the lookup) to link; omit to create the release first
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    releaseId?: string | null;
    /**
     * Required when creating; optional when linking
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    source?: BulkEditRequestBulkEditReleaseLinkSourceEnum;
    /**
     * Release id at `source`, when creating
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    sourceId?: string | null;
    /**
     * The release's id(s) at its source, e.g. the Discogs release id — the only value that reaches `sourceReleaseId`. Required and non-empty on both paths: `release_id` is the WMC id, and the service does not derive this from `source_id`.
     * @type {Array<string>}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    sourceReleaseIds: Array<string>;
    /**
     * Required when linking
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    releaseTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    dateReleased?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    releaseLabels?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    catNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    mediaType?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    format?: string;
    /**
     * Release barcode: 12-digit UPC or 13-digit EAN. Spaces and hyphens are ignored.
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    barcode?: string;
}


/**
 * @export
 */
export const BulkEditRequestBulkEditReleaseLinkSourceEnum = {
    Discogs: 'discogs',
    Musicbrainz: 'musicbrainz',
    Spotify: 'spotify',
    Deezer: 'deezer',
    Ppl: 'ppl',
    Other: 'other'
} as const;
export type BulkEditRequestBulkEditReleaseLinkSourceEnum = typeof BulkEditRequestBulkEditReleaseLinkSourceEnum[keyof typeof BulkEditRequestBulkEditReleaseLinkSourceEnum];


/**
 * Check if a given object implements the BulkEditRequestBulkEditReleaseLink interface.
 */
export function instanceOfBulkEditRequestBulkEditReleaseLink(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sourceReleaseIds" in value;

    return isInstance;
}

export function BulkEditRequestBulkEditReleaseLinkFromJSON(json: any): BulkEditRequestBulkEditReleaseLink {
    return BulkEditRequestBulkEditReleaseLinkFromJSONTyped(json, false);
}

export function BulkEditRequestBulkEditReleaseLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditRequestBulkEditReleaseLink {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseId': !exists(json, 'release_id') ? undefined : json['release_id'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'sourceId': !exists(json, 'source_id') ? undefined : json['source_id'],
        'sourceReleaseIds': json['source_release_ids'],
        'releaseTitle': !exists(json, 'releaseTitle') ? undefined : json['releaseTitle'],
        'dateReleased': !exists(json, 'dateReleased') ? undefined : json['dateReleased'],
        'releaseLabels': !exists(json, 'releaseLabels') ? undefined : json['releaseLabels'],
        'catNumbers': !exists(json, 'catNumbers') ? undefined : json['catNumbers'],
        'mediaType': !exists(json, 'mediaType') ? undefined : json['mediaType'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'barcode': !exists(json, 'barcode') ? undefined : json['barcode'],
    };
}

export function BulkEditRequestBulkEditReleaseLinkToJSON(value?: BulkEditRequestBulkEditReleaseLink | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_id': value.releaseId,
        'source': value.source,
        'source_id': value.sourceId,
        'source_release_ids': value.sourceReleaseIds,
        'releaseTitle': value.releaseTitle,
        'dateReleased': value.dateReleased,
        'releaseLabels': value.releaseLabels,
        'catNumbers': value.catNumbers,
        'mediaType': value.mediaType,
        'format': value.format,
        'barcode': value.barcode,
    };
}

